export default "__VITE_ASSET__BQIo$KUj__"